var svg = '<div class="svgDiv"><svg version="1.1" class="hr" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x="0px" y="0px" viewBox="0 0 1355 40" style="enable-background:new 0 0 1355 40;" xml:space="preserve"><line class="st0 vert" x1="684.5" y1="0" x2="684.5" y2="40" /><line class="st0 animateright" x1="1355" y1="20" x2="684.5" y2="20" /><line class="st0 animate" x1="670.5" y1="20" x2="0" y2="20" /><line class="st1 vert2" x1="670.5" y1="7" x2="670.5" y2="33" /></svg></div>';

var hr = document.querySelectorAll('.wp-block-separator');

// insert before each hr element
hr.forEach(function (hr) {
  // console.log(hr);
  hr.insertAdjacentHTML('beforebegin', svg);
  hr.remove();
} ); 
